/* eslint no-inline-comments: 0 */

const ListItems = () => import( /* webpackChunkName: "group-cms" */ `./items/list.vue` );
const AddItem = () => import( /* webpackChunkName: "group-cms" */ `./items/add.vue` );
const EditItem = () => import( /* webpackChunkName: "group-cms" */ `./items/edit.vue` );
const Settings = () => import( /* webpackChunkName: "group-cms" */ `./settings.vue` );
const FAQ = () => import( /* webpackChunkName: "group-cms" */ `./faq-editor.vue` );

export default {
	path: `cms`,
	children: [
		{
			path: ``,
			name: `list-cms-items`,
			component: ListItems,
			meta: {
				title: `CMS`
			}
		},
		{
			path: `new`,
			name: `add-cms-item`,
			component: AddItem,
			meta: {
				title: `Add Article`
			}
		},
		{
			path: `:uuid`,
			name: `edit-cms-item`,
			component: EditItem,
			meta: {
				title: `Edit Article`
			}
		},
		{
			path: `faq`,
			name: `cms-faq`,
			component: FAQ,
			meta: {
				title: `FAQ`
			}
		},
		{
			path: `settings`,
			name: `cms-settings`,
			component: Settings,
			meta: {
				title: `CMS Settings`
			}
		}
	]
};
